<template>
  <div class="status-scheduled-date">
    <c-icon :icon="statusIcon" />
    <div>{{ date }}</div>
  </div>
</template>

<script>
import Icon from "@/components/icon";

export default {
  name: "candidates-scheduled-date",
  components: {
    "c-icon": Icon,
  },
  props: {
    statusId: {
      type: Number,
      default: () => 0,
    },
    date: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    statusIcon() {
      if (this.statusId === 12) {
        return "checklist";
      }
      if (this.statusId === 1) {
        return "phone";
      }
      if (this.statusId === 2) {
        return "conversation";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .c-icon svg {
  top: 0;
  left: 0;
  fill: none;
}
.status-scheduled-date {
  display: flex;
  font-weight: 500;
  font-size: 12px;
  margin-top: 7px;

  & svg {
    margin-right: 7px;
  }
}
</style>
